var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({staticClass:"ui-button",class:_vm.computeClass,attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }